import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "procedure-review flex flex-row space-between" }
const _hoisted_2 = { class: "left-side w-2/5 ml-6 mt-2 flex flex-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl py-4 border-b border-gray-300" }, "Other Policy Criteria", -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Selected criterion: ")
const _hoisted_6 = {
  key: 0,
  class: "font-mono bg-blue-200 px-2 py-1 ml-1 rounded"
}
const _hoisted_7 = {
  key: 1,
  class: "font-mono px-2 py-1 ml-1"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "adjudication-comments p-2 my-4 text-lg w-full border-2 rounded-lg" }
const _hoisted_10 = {
  key: 2,
  class: "flex space-between w-full mb-4"
}
const _hoisted_11 = { class: "right-side w-3/5 mt-2 mr-4 h-full flex flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProcedureCriteriaList = _resolveComponent("ProcedureCriteriaList")!
  const _component_Recommendation = _resolveComponent("Recommendation")!
  const _component_SummaryProperty = _resolveComponent("SummaryProperty")!
  const _component_ClinicalDetails = _resolveComponent("ClinicalDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_ProcedureCriteriaList, {
        historical: _ctx.historical,
        selected: _ctx.selectedCriterion,
        "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCriterion) = $event)),
        criteria: _ctx.criteria,
        class: "flex-grow overflow-scroll"
      }, null, 8, ["historical", "selected", "criteria"]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_ctx.selectedCriterion)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedCriterion), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "N/A"))
      ]),
      (!_ctx.historical)
        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
            key: 0,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comments) = $event)),
            rows: "4",
            class: "adjudication-comments p-2 my-4 w-full border-2 rounded-lg",
            placeholder: "Add comments here"
          }, null, 512)), [
            [_vModelText, _ctx.comments]
          ])
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_SummaryProperty, {
              class: "recommendation-status pt-4",
              name: "Clinical Review"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Recommendation, {
                  status: _ctx.formatApproval(_ctx.procedure.approved)
                }, null, 8, ["status"])
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.procedure.comments), 1)
          ])),
      (!_ctx.historical)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.declineProcedure && _ctx.declineProcedure(...args))),
              class: "button flex-1 font-bold text-white bg-red-500 px-4 py-1 rounded cursor-pointer",
              type: "button"
            }, " Deny "),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.approveProcedure && _ctx.approveProcedure(...args))),
              class: "button flex-1 font-bold text-white bg-green-500 px-4 py-1 rounded cursor-pointer ml-4",
              type: "button"
            }, " Approve ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_ClinicalDetails, { class: "flex-grow overflow-scroll" })
    ])
  ]))
}